import styled from 'styled-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import RowHeader from './RowHeaderAccordion';
import RowTable from './RowTableAccordion';

const AccordionTableGroup = ({ rows, columnsHeader, columnsBody }) => {
    // Solo mostrar grupos con datos en purchaseOrders
    const validGroups = rows?.filter(
        (group) =>
            group &&
            Object.keys(group).length > 0 &&
            Array.isArray(group.purchaseOrders) &&
            group.purchaseOrders.length > 0
    );

    return (
        <>
            {validGroups.length > 0 ? (
                validGroups.map((group, index) => (
                    <AccordionStyle key={index}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Container>
                                <RowHeader
                                    columns={columnsHeader}
                                    row={group}
                                />
                            </Container>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Title>Detalle</Title>
                            <Container>
                                <RowTable
                                    columns={columnsBody}
                                    rows={group.purchaseOrders}
                                />
                            </Container>
                        </AccordionDetails>
                    </AccordionStyle>
                ))
            ) : (
                <NoResultsContainer>
                    <p>¡Ups! No se encontraron resultados para tu búsqueda.</p>
                </NoResultsContainer>
            )}
        </>
    );
};

export default AccordionTableGroup;

const AccordionStyle = styled(Accordion)`
    border-radius: 20px !important;
    box-shadow: none;
    &::before {
        content: '';
        width: 0px;
        height: 0px;
    }
`;

const Container = styled.div`
    width: calc(100% - 2rem);
    padding: 1rem;
    display: flex;
    flex-direction: column;
`;

const Title = styled.h3`
    font-size: 1.2rem;
    color: #b31d15;
    text-decoration: underline;
`;

const NoResultsContainer = styled.div`
    padding: 2rem;
    text-align: center;
    color: #999;
`;
